<template>
  <div
    class="landingPage landing-relative"
    v-if="loading == false && status == false"
  >
    <img :src="image" alt="" />
  </div>
  <div class="landingPage" v-else-if="loading == false && status == true">
    <div class="mainBanner">
      <img
        :src="typeof mEvent !== 'undefined' ? mEvent.banner_img : ''"
        alt="company_image"
        class="company_banner"
      />

      <!-- <img
        :src="typeof mEvent !== 'undefined' ? mEvent.logo_img : ''"
        class="company_icon"
      /> -->
    </div>

    <div class="eventDescription">
      <div class="brief">
        <h1 class="event_name">
          {{ typeof mEvent !== 'undefined' ? mEvent.event_name : '' }}
        </h1>
        <h4 class="left-border">イベント概要</h4>

        <p
          class="html-content"
          v-html="
            typeof mLPeventOutline !== 'undefined'
              ? mLPeventOutline.event_outline
              : ''
          "
        ></p>
      </div>
      <div class="btn-app">
        <v-btn class="btn-app-top" @click="redirectEntrySide()"
          >参加申し込み</v-btn
        >
      </div>
      <div class="companies">
        <div class="title">
          <div class="line"></div>
          <h1>企業一覧</h1>
        </div>
        <!-- <div class="optionCompany">
          表示 / Display :
          <div class="form-select">
            <select name="company_list_option" v-model="company_list_option">
              <option value="1">
                リスト表示 / List
              </option>
              <option value="2">
                グリッド表示 / Grid
              </option>
            </select>
          </div>
        </div> -->
        <div class="list-company-container">
          <!-- <div v-if="company_list_option == 1"> -->
          <div
            class="listCompany"
            v-if="LandingPageLink.listCompany.length > 0"
          >
            <CompanyItem
              v-for="item in LandingPageLink.listCompany"
              :key="item && item.id"
              :item="item"
            />
          </div>
          <div class="undisplay-company" v-else>
            登録完了した企業はございません。
          </div>
          <!-- </div> -->
          <!-- <div class="company-table" v-else-if="company_list_option == 2">
            <v-data-table
              :headers="headers"
              :items="
                LandingPageLink.listCompany !== null &&
                typeof LandingPageLink.listCompany !== 'undefined' &&
                LandingPageLink.listCompany.length !== 0
                  ? LandingPageLink.listCompany
                  : []
              "
              :items-per-page="10"
              class="elevation-1 app_table"
              mobile-breakpoint="0"
            >
              <template v-slot:[`item.information.industry_type`]="{ item }">
                {{
                  item.information !== null
                    ? industryTypeFormatLandingPage(
                        item.information.industry_type
                      )
                    : ''
                }}
              </template>
              <template v-slot:[`item.company_name`]="{ item }">
                {{
                  item.information !== null &&
                  item.information.complete_flag === 1
                    ? item.information.company_name
                    : item.company_name
                }}
              </template>
            </v-data-table>
          </div> -->
        </div>

        <v-btn class="btnApply" @click="redirectEntrySide()"
          >参加申し込み</v-btn
        >
      </div>
      <div class="footer">
        <h4 class="left-border" v-if="checkDisplayHr()">
          主催者・運営者/Organizer・Operator
        </h4>

        <table class="table-homepage2">
          <tbody>
            <tr
              v-if="mEvent !== null && mEvent.organizer_name_display == DISPLAY"
            >
              <td>
                {{
                  $t('top-page.text-field.organize-name', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                {{ mEvent.organizer_name }}
              </td>
            </tr>
            <tr v-if="mEvent !== null && mEvent.cooperator_display == DISPLAY">
              <td>
                {{
                  $t('top-page.text-field.cooperator', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                {{ mEvent.cooperator }}
              </td>
            </tr>

            <tr v-if="mEvent !== null && mEvent.sponsor_display == DISPLAY">
              <td>
                {{
                  $t('top-page.text-field.sponsor', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">{{ mEvent.sponsor }}</td>
            </tr>
            <tr v-if="mEvent !== null && mEvent.operator_display == DISPLAY">
              <td>
                {{
                  $t('top-page.text-field.operator', {
                    split: '/'
                  })
                }}
              </td>
              <td class="td-right">
                {{ mEvent.operator }}
              </td>
            </tr>
          </tbody>
        </table>

        <hr class="separateLine" />
        <div class="contact">
          <h4>お問い合わせ先 / Contact</h4>
          <div class="contactItem">
            <v-btn icon color="#e8320e"> <v-icon>mdi-account</v-icon> </v-btn>
            {{ typeof mEvent !== 'undefined' ? mEvent.contact_to : '' }}
          </div>
          <div class="contactItem">
            <v-btn icon color="#e8320e" :href="`mailto:${mEvent.contact_mail}`">
              <v-icon>mdi-email</v-icon>
            </v-btn>
            <a :href="`mailto:${mEvent.contact_mail}`">
              {{ typeof mEvent !== 'undefined' ? mEvent.contact_mail : '' }}</a
            >
          </div>
          <div class="contactItem">
            <v-btn icon color="#e8320e" :href="`tel:${mEvent.contact_phone}`">
              <v-icon>mdi-phone</v-icon>
            </v-btn>
            <a :href="`tel:${mEvent.contact_phone}`">
              {{ typeof mEvent !== 'undefined' ? mEvent.contact_phone : '' }}
            </a>
          </div>
          <div class="contactItem">
            <v-btn icon color="#e8320e">
              <v-icon>mdi-map</v-icon>
            </v-btn>
            {{ typeof mEvent !== 'undefined' ? mEvent.contact_address : '' }}
          </div>
        </div>
      </div>
    </div>

    <ScrollTopBtn />
  </div>
  <div class="landingPage landing-relative" v-else>
    <img :src="loadingImage" alt="test-data" />
  </div>
</template>

<script>
import ScrollTopBtn from '@/components/ScrollTopBtn';
import CompanyItem from './CompanyItem.vue';
import { masterMixin } from '@/mixins/masterMixin.js';
import LoadingGif from '@/assets/image/loading.gif';
import {
  UN_DISPLAY_TAG,
  DISPLAY_TAG,
  LANG_CODE_JAPANESE_LOWERCASE,
  LANG_CODE_JAPANESE_UPPERCASE,
  LANG_CODE_VIETNAMESE_LOWERCASE,
  LANG_CODE_VIETNAMESE_UPPERCASE
} from '@/common/constants';
import { Trans } from '@/plugins/translation.js';
import { mapGetters } from 'vuex';

export default {
  mixins: [masterMixin],
  data() {
    return {
      loading: true,
      status: false,
      loadingImage: LoadingGif,
      image:
        'https://cdn.dribbble.com/users/215588/screenshots/909046/oops.png',
      company_data: '',
      company_list_option: 1,
      headers: [
        {
          text: 'Company Name',
          sortable: false,
          align: 'start',
          value: 'company_name'
        },

        {
          text: 'Business Content',
          align: 'start',
          sortable: false,
          value: 'information.business_content'
        },

        {
          text: 'Industry Type',
          align: 'start',
          sortable: false,
          value: 'information.industry_type'
        },
        {
          text: 'Office Location',
          align: 'start',
          sortable: false,
          value: 'information.office_location'
        }
      ]
    };
  },
  components: {
    ScrollTopBtn,
    CompanyItem
  },

  computed: {
    ...mapGetters({
      LandingPageLink: 'getLandingPageLink',
      mIndustryTypeLandingPage: 'getMIndustryTypeLandingPage',
      mEvent: 'getMEventLandingPage',
      mLPeventOutline: 'getLPEventOutline',
      dataLang: 'getLang',
      dataLanguageFromServe: 'getDataLanguage',
      getContractId: 'getContractId',
      getEventCode: 'getEventCode'
    }),
    getCompanyName() {
      if (
        this.item.information !== null &&
        this.item.information.complete_flag === 1
      ) {
        return this.item !== null ? this.item.company_name : '';
      } else {
        return this.item.information !== null
          ? this.item.information.company_name
          : '';
      }
    }
  },

  methods: {
    getLanguageFromLS() {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      return objFromLS.sekisho_lang || null;
    },

    async setLanguageFromLS(_lang) {
      const keyStore = this.getContractId + this.getEventCode;

      const objFromLS =
        localStorage.getItem(keyStore) !== null
          ? JSON.parse(localStorage.getItem(keyStore))
          : null;

      const newObj = {
        ...objFromLS,
        sekisho_lang: _lang
      };

      await localStorage.setItem(keyStore, JSON.stringify(newObj));
    },

    changeLanguage(_lang, title) {
      this.setLanguageFromLS(_lang);
      Trans.changeLanguage(_lang);
      this.select = title;
      this.$store.dispatch('changeLanguage', { lang: _lang });
    },

    async setSelectedLanguage(lang_code) {
      const langActive = this.dataLanguageFromServer.filter(
        (lang) => lang.lang_code === lang_code
      );

      await this.changeLanguage(lang_code, this.select);

      Trans.changeLanguage(lang_code);

      this.select = langActive.length > 0 ? langActive[0].lang_name : '';
    },

    checkLangExisted(lang) {
      if (
        lang === LANG_CODE_VIETNAMESE_UPPERCASE ||
        lang === LANG_CODE_VIETNAMESE_LOWERCASE ||
        lang === LANG_CODE_JAPANESE_UPPERCASE ||
        lang === LANG_CODE_JAPANESE_LOWERCASE
      ) {
        this.setSelectedLanguage(lang);
        return;
      }
    },

    redirectEntrySide() {
      this.$router.push({ path: '/entry/' + this.getPathName() }, () => {});
    },
    getPathName() {
      return (
        this.LandingPageLink.mEvent.contract_code +
        '/' +
        this.LandingPageLink.mEvent.event_code
      );
    },

    industryTypeFormatLandingPage: function (id) {
      const arr = this.mIndustryTypeLandingPage.filter((ele) => ele.id === id);
      if (arr.length > 0) {
        return arr[0].name_convert;
      } else return null;
    },

    checkLandingPage() {
      if (this.$route) {
        const { params } = this.$route;
        this.loading = true;

        setTimeout(() => {
          if (params.contractID && params.eventID) {
            const data = {
              contract_code: params.contractID,
              event_code: params.eventID
            };
            this.$store.dispatch('landingPageLink', data).then((status) => {
              this.loading = false;
              this.status = status;
              const { lang } = this.$route.query;
              if (lang) {
                this.checkLangExisted(lang);
              }
            });
          }
        }, 0);
      }
    },
    checkDisplayHr() {
      if (this.mEvent !== null) {
        const {
          organizer_name_display,
          cooperator_display,
          sponsor_display,
          operator_display
        } = this.mEvent;
        if (
          sponsor_display === this.UN_DISPLAY_TAG &&
          operator_display === this.UN_DISPLAY_TAG &&
          organizer_name_display === this.UN_DISPLAY_TAG &&
          cooperator_display === this.UN_DISPLAY_TAG
        ) {
          return false;
        }
      }
      return true;
    }
  },
  created() {
    this.checkLandingPage();
    this.DISPLAY_TAG = DISPLAY_TAG;
    this.UN_DISPLAY_TAG = UN_DISPLAY_TAG;
  }
};
</script>

<style lang="scss">
@import '@/style/common.scss';
@import '@/style/devices.scss';
@import './landingPage.scss';
</style>
